import { defineNuxtPlugin } from '#app/nuxt'
import { LazyHomeEvents, LazyNewsListNews, LazyNews, LazyAccordionCurriculum, LazyArticle, LazyArticleBGColor, LazyArticleCourseAndInfo, LazyArticleCourseAndInfoStricto, LazyArticleCourseInfo, LazyArticleCourseInfoAndCarousel, LazyArticleGroupTeacherStaffNaousado, LazyArticleImageText, LazyArticleImageTextButton, LazyArticleInfoCourse, LazyArticleLabel, LazyArticleTitle, LazyArticleTitleAndText, LazyArticleVideo, LazyBannersBannerBGImage, LazyBannersBannerCarousel, LazyBannersBannerGraduation, LazyBannersBannerGroupNãoUsado, LazyBannersBannerGroupTwoNãoUsado, LazyBannersBannerHome, LazyBannersBannerInfo, LazyBannersBannerPesquisa, LazyBannersBannerSchools, LazyBannersBannerSearchIMG, LazyBannersBannerVideo, LazyBannersUnoBanner, LazyBreadcrumbs, LazyButtonDefault, LazyButtonDefaultLink, LazyButtonLink, LazyButtonMoreInfo, LazyButtonDropdownButton, LazyButtonSeeToo, LazyButtonGroupSearch, LazyButtonGroupHomeButtonGroup, LazyButtonGroupMasterButtonNavigator, LazyCard404, LazyCardInfo, LazyCardRedirect, LazyCard, LazyCardCourseInfos, LazyCardDeans, LazyCardDefaultImageCoordination, LazyCardHighlightMaster, LazyCardImageTextButton, LazyCardImageTextDescription, LazyCardInfoCourseMaster, LazyCardTeacherCourseInfo, LazyCardTeachers, LazyCardTextOrImage, LazyCardVacancies, LazyCardVacanciesPreview, LazyCardSchoolCardCourses, LazyCardSchoolsCards, LazyCarousel, LazyCarouselMedium, LazyCatalogEAD, LazyCatalogPos, LazyCatalogPresencial, LazyFooterFull, LazyGridButtonGrid5, LazyGridButtonGroupSearch, LazyGridEvents, LazyGridGrid4Banner, LazyGridAligned, LazyGridDefault, LazyGridForBanner, LazyGridRelativeBGColor, LazyGridThree, LazyGridHighlight, LazyGridMiddle, LazyGridNews, LazyGridRelative, LazyGridSchools, LazyGridSectionButtonGroup, LazyHighlightsCard3HighlightMaster, LazyHighlightsCourseGraduationMEC, LazyHighlightsCourses, LazyHighlightsCoursesEAD, LazyMenuButtonMenu, LazyMixComponentsArticleAccordion, LazyMixComponentsArticleCard, LazyPreloadClass, LazyShareIcons, LazyTimeline, LazyScriptAriaLoadingIndicator, LazyScriptCarbonAds, LazyScriptCrisp, LazyScriptGoogleAdsense, LazyScriptGoogleMaps, LazyScriptIntercom, LazyScriptLemonSqueezy, LazyScriptLoadingIndicator, LazyScriptStripePricingTable, LazyScriptVimeoPlayer, LazyScriptYouTubePlayer } from '#components'
const lazyGlobalComponents = [
  ["HomeEvents", LazyHomeEvents],
["NewsListNews", LazyNewsListNews],
["News", LazyNews],
["AccordionCurriculum", LazyAccordionCurriculum],
["Article", LazyArticle],
["ArticleBGColor", LazyArticleBGColor],
["ArticleCourseAndInfo", LazyArticleCourseAndInfo],
["ArticleCourseAndInfoStricto", LazyArticleCourseAndInfoStricto],
["ArticleCourseInfo", LazyArticleCourseInfo],
["ArticleCourseInfoAndCarousel", LazyArticleCourseInfoAndCarousel],
["ArticleGroupTeacherStaffNaousado", LazyArticleGroupTeacherStaffNaousado],
["ArticleImageText", LazyArticleImageText],
["ArticleImageTextButton", LazyArticleImageTextButton],
["ArticleInfoCourse", LazyArticleInfoCourse],
["ArticleLabel", LazyArticleLabel],
["ArticleTitle", LazyArticleTitle],
["ArticleTitleAndText", LazyArticleTitleAndText],
["ArticleVideo", LazyArticleVideo],
["BannersBannerBGImage", LazyBannersBannerBGImage],
["BannersBannerCarousel", LazyBannersBannerCarousel],
["BannersBannerGraduation", LazyBannersBannerGraduation],
["BannersBannerGroupNãoUsado", LazyBannersBannerGroupNãoUsado],
["BannersBannerGroupTwoNãoUsado", LazyBannersBannerGroupTwoNãoUsado],
["BannersBannerHome", LazyBannersBannerHome],
["BannersBannerInfo", LazyBannersBannerInfo],
["BannersBannerPesquisa", LazyBannersBannerPesquisa],
["BannersBannerSchools", LazyBannersBannerSchools],
["BannersBannerSearchIMG", LazyBannersBannerSearchIMG],
["BannersBannerVideo", LazyBannersBannerVideo],
["BannersUnoBanner", LazyBannersUnoBanner],
["Breadcrumbs", LazyBreadcrumbs],
["ButtonDefault", LazyButtonDefault],
["ButtonDefaultLink", LazyButtonDefaultLink],
["ButtonLink", LazyButtonLink],
["ButtonMoreInfo", LazyButtonMoreInfo],
["ButtonDropdownButton", LazyButtonDropdownButton],
["ButtonSeeToo", LazyButtonSeeToo],
["ButtonGroupSearch", LazyButtonGroupSearch],
["ButtonGroupHomeButtonGroup", LazyButtonGroupHomeButtonGroup],
["ButtonGroupMasterButtonNavigator", LazyButtonGroupMasterButtonNavigator],
["Card404", LazyCard404],
["CardInfo", LazyCardInfo],
["CardRedirect", LazyCardRedirect],
["Card", LazyCard],
["CardCourseInfos", LazyCardCourseInfos],
["CardDeans", LazyCardDeans],
["CardDefaultImageCoordination", LazyCardDefaultImageCoordination],
["CardHighlightMaster", LazyCardHighlightMaster],
["CardImageTextButton", LazyCardImageTextButton],
["CardImageTextDescription", LazyCardImageTextDescription],
["CardInfoCourseMaster", LazyCardInfoCourseMaster],
["CardTeacherCourseInfo", LazyCardTeacherCourseInfo],
["CardTeachers", LazyCardTeachers],
["CardTextOrImage", LazyCardTextOrImage],
["CardVacancies", LazyCardVacancies],
["CardVacanciesPreview", LazyCardVacanciesPreview],
["CardSchoolCardCourses", LazyCardSchoolCardCourses],
["CardSchoolsCards", LazyCardSchoolsCards],
["Carousel", LazyCarousel],
["CarouselMedium", LazyCarouselMedium],
["CatalogEAD", LazyCatalogEAD],
["CatalogPos", LazyCatalogPos],
["CatalogPresencial", LazyCatalogPresencial],
["FooterFull", LazyFooterFull],
["GridButtonGrid5", LazyGridButtonGrid5],
["GridButtonGroupSearch", LazyGridButtonGroupSearch],
["GridEvents", LazyGridEvents],
["GridGrid4Banner", LazyGridGrid4Banner],
["GridAligned", LazyGridAligned],
["GridDefault", LazyGridDefault],
["GridForBanner", LazyGridForBanner],
["GridRelativeBGColor", LazyGridRelativeBGColor],
["GridThree", LazyGridThree],
["GridHighlight", LazyGridHighlight],
["GridMiddle", LazyGridMiddle],
["GridNews", LazyGridNews],
["GridRelative", LazyGridRelative],
["GridSchools", LazyGridSchools],
["GridSectionButtonGroup", LazyGridSectionButtonGroup],
["HighlightsCard3HighlightMaster", LazyHighlightsCard3HighlightMaster],
["HighlightsCourseGraduationMEC", LazyHighlightsCourseGraduationMEC],
["HighlightsCourses", LazyHighlightsCourses],
["HighlightsCoursesEAD", LazyHighlightsCoursesEAD],
["MenuButtonMenu", LazyMenuButtonMenu],
["MixComponentsArticleAccordion", LazyMixComponentsArticleAccordion],
["MixComponentsArticleCard", LazyMixComponentsArticleCard],
["PreloadClass", LazyPreloadClass],
["ShareIcons", LazyShareIcons],
["Timeline", LazyTimeline],
["ScriptAriaLoadingIndicator", LazyScriptAriaLoadingIndicator],
["ScriptCarbonAds", LazyScriptCarbonAds],
["ScriptCrisp", LazyScriptCrisp],
["ScriptGoogleAdsense", LazyScriptGoogleAdsense],
["ScriptGoogleMaps", LazyScriptGoogleMaps],
["ScriptIntercom", LazyScriptIntercom],
["ScriptLemonSqueezy", LazyScriptLemonSqueezy],
["ScriptLoadingIndicator", LazyScriptLoadingIndicator],
["ScriptStripePricingTable", LazyScriptStripePricingTable],
["ScriptVimeoPlayer", LazyScriptVimeoPlayer],
["ScriptYouTubePlayer", LazyScriptYouTubePlayer],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
